import { MediaToolsProviderService } from '@addins/core/singlecallcard';
import { AttachmentService, MediaSource } from '@addins/media';
import { Injectable } from '@angular/core';
import { Tool } from '@services/tools';
import { AddinExecute, Execute } from '@techwan/ionic-core';

@AddinExecute({
  name: 'Add media tool for file'
})
@Injectable()
export class MediaFileToolService extends Execute {
  constructor(private mediaProvider: MediaToolsProviderService, private attachmentService: AttachmentService) {
    super();
  }

  execute() {
    const fileTool = new Tool('Saga.AttachmentType.File', 'document', '', 4, callcard =>
      this.attachmentService.createMediaMessage(callcard.ObjGuid, MediaSource.File)
    );
    this.mediaProvider.register(fileTool);
  }
}
